<script setup lang="ts">
/**
 * UI-kit component
 * Category: Footers
 * Name: FooterLink
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=3886-19580
 *
 * A footer navigation link on the dark ultraviolet surface: 28px row, Body/M label
 * that fills the row (so the optional badge always sits at the GROUP's end — groups
 * are 164px wide, not the column width; see 5075-1469). Never underlined, never
 * truncated — long labels wrap. The badge (sunshine/400 pill)
 * keeps full saturation even when the link is disabled; disabled dims the label
 * only and drops the anchor. Readable ONLY on the footer's dark surface.
 * The action/inverse/* ramp is missing from the installed LumeeUI tokens (dsGap) —
 * state colors fall back to text-inverse + the ultraviolet brand ramp.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui.
 */
// types
import type { FooterLinkProps } from '../types/interfaces'

defineOptions({
  name: 'FooterLink',
})

withDefaults(defineProps<FooterLinkProps>(), {
  badgeLabel: '',
  disabled: false,
})
</script>

<template>
  <component
    :is="disabled ? 'span' : 'a'"
    class="footer-link"
    :class="{ 'footer-link--disabled': disabled }"
    :href="disabled ? undefined : url"
    :aria-disabled="disabled ? 'true' : undefined"
  >
    <span class="footer-link__label btly-text-body-m">{{ label }}</span>
    <span
      v-if="badgeLabel"
      class="footer-link__badge btly-text-label-s"
    >{{ badgeLabel }}</span>
  </component>
</template>

<style lang="scss" scoped src="../styles/_footer-link.scss" />
